module.exports = __webpack_public_path__ + "fonts/Gerade_f87ccd8ddc2a9c3f03867ebc64a8f90d.woff";